import { jsx as r } from "react/jsx-runtime";
import { useState as c } from "react";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import "../../index-DNTqwtVt.js";
import { student as u } from "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { useTheme as f, Box as x, ClickAwayListener as h, Tooltip as I, Chip as C, Avatar as T } from "@mui/material";
const V = ({ studentId: l }) => {
  const m = f(), [p, e] = c(0), { isPending: n, data: t } = new u.indicators({ studentId: l }).ToQuery(), a = (o, i) => {
    o.stopPropagation(), e(i);
  };
  return n || !t || t.length === 0 ? null : /* @__PURE__ */ r(x, { sx: { display: "flex", gap: "4px", flexWrap: "wrap", maxWidth: "700px" }, children: t == null ? void 0 : t.map((o) => {
    let i = o.Colour ? o.Colour : "#ffffff", s = m.palette.getContrastText(i);
    return /* @__PURE__ */ r(h, { onClickAway: () => p > 0 && e(0), children: /* @__PURE__ */ r(I, { arrow: !0, title: o.Tooltip, open: o.IndicatorId === p, slotProps: {
      popper: {
        disablePortal: !0
      }
    }, children: /* @__PURE__ */ r(C, { onClick: (d) => a(d, o.IndicatorId), size: "small", avatar: /* @__PURE__ */ r(T, { variant: "rounded", sx: { bgcolor: i, "&.MuiChip-avatarSmall": { color: s } }, children: o.Text }), label: o.Caption }) }, o.IndicatorId) }, o.IndicatorId);
  }) });
};
export {
  V as IndicatorChipsForStudent
};
//# sourceMappingURL=IndicatorChipsForStudent.js.map
